const ConfigServer = {

    //local - produccion
    urlLocal: 'https://apilacabana.aliatic.app',
    //urlLocal: 'http://localhost:4000',
    urlServerDev: 'http://localhost:4000'
}

export default ConfigServer